import React, { useCallback, useState, useEffect, useRef } from "react";
import { useLocation, matchPath, NavLink } from "react-router-dom";
import useIsMobile from "../../utils/useIsMobile";
import { isAuthenticated } from "../../services/authService";
import Logo from "./Logo";
import golfImage from "../../assets/site-icon.svg";
import LogNav from "./LoggedNav";

// Define routes where the light logo is used
const lightLogoRoutes = [
  "/renew-pay-card",
  "/faq",
  "/contact",
  "/thank-you",
  // Add other paths here
];

const LogoRenderer = () => {
  const { pathname } = useLocation();
  const isMobile = useIsMobile(940);
  const hasLightThemePage = lightLogoRoutes.some((path) =>
    matchPath({ path, exact: true }, pathname)
  );
  const isThemeLight = hasLightThemePage || isMobile;

  return <Logo color={isThemeLight ? "white" : "white"} />;
};

const Header = () => {
  const [isOpen, setOpen] = useState(false);
  const [isLogged, setLogged] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const ref = useRef();

  const toggleNav = () => setOpen((prev) => !prev);

  // Handle click outside to close navigation
  useEffect(() => {
    const checkIfClickOutside = (e) => {
      if (isOpen && ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", checkIfClickOutside);
    return () => document.removeEventListener("click", checkIfClickOutside);
  }, [isOpen]);

  // Check authentication status
  useEffect(() => {
    setLogged(isAuthenticated());
  }, []);

  // Handle scroll to toggle sticky class
  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50); // Adjust threshold as needed
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const renderNavPrimaryItems = useCallback(
    () => (
      <div className="header__nav__item">
        <NavLink
          to="/loged-user-home"
          className="header__nav__item-link flx-center"
          onClick={toggleNav}
        >
          <img
            src={require("../../assets/images/header/contact.svg").default}
            className="header__nav__item-link-person"
            alt="icon"
          />
          <span>Club Login</span>
        </NavLink>
      </div>
    ),
    []
  );

  return (
    <header className={``} ref={ref}>
      <div className="page-width">
        <div className="header-block">
          {/* Main Navigation */}
          {/* <ul className={`header__nav ${isOpen ? "is--open" : ""}`}>
            {["/for-player", "/for-club", "/about", "/contact"].map(
              (path, index) => (
                <li className="header__nav__item" key={index}>
                  <NavLink
                    to={path}
                    className="header__nav__item-link"
                    style={{ "--nav-icon": `url(${golfImage})` }}
                  >
                    {path.split("/")[1].toUpperCase().replace("-", " ")}
                  </NavLink>
                </li>
              )
            )}
          </ul> */}

          {/* Logo */}
          <LogoRenderer />

          {/* Login, Signup, and Store Links */}
          <ul className="header__nav">
            {!isLogged ? (
              <>
                <li className="header__nav__item is--nav-action">
                  {renderNavPrimaryItems()}
                </li>
                <li className="header__nav__item">
                  <NavLink
                    to="/club-detail"
                    className="header__nav__item-link"
                    onClick={toggleNav}
                  >
                    Sign Up
                  </NavLink>
                </li>
              </>
            ) : (
              <div>
                {/* <NavLink
                  to="/loged-user-home"
                  className="header__nav__item-link"
                >
                  <img
                    src={
                      require("../../assets/images/header/contact.svg").default
                    }
                    className="header__nav__item-link-person"
                    alt="icon"
                  />
                  <span>MY CLUB</span>
                </NavLink> */}
                <LogNav/>
              </div>
            )}
            {/* <li className="header__nav__item store">
              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    require("../../assets/images/header/googlestore.svg")
                      .default
                  }
                  alt="Google Play Store"
                />
              </a>
            </li>
            <li className="header__nav__item store">
              <a
                href="https://www.apple.com/in/app-store/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={
                    require("../../assets/images/header/applestore.svg").default
                  }
                  alt="Apple App Store"
                />
              </a>
            </li> */}
          </ul>

          {/* Mobile Menu */}
          <div className="header__mob">
            {isLogged ? (
              <div className="header__nav__item">
                {/* <NavLink
                  to="/loged-user-home"
                  className="header__nav__item-link flx-center"
                >
                  <img
                    src={
                      require("../../assets/images/header/contact.svg").default
                    }
                    className="header__nav__item-link-person"
                    alt="icon"
                  />
                  <span>MY CLUB</span>
                </NavLink> */}
                <LogNav/>
              </div>
            ) : (
              renderNavPrimaryItems()
            )}

            {/* <button
              className={`header__mob__hamburger__menu ${
                isOpen ? "is--open" : ""
              }`}
              onClick={toggleNav}
            >
            
              <div className="bar1"></div>
              <div className="bar2"></div>
              <div className="bar3"></div>
              
            </button> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
